import Image from 'react-bootstrap/Image'

import TituloNegrito from './TituloNegrito'
import CardProdutoFair4Them from './CardProdutoFair4Them'

import { retornarTexto } from '../helpers/textoHelper'

import caes from '../images/caes.png'
import gatos from '../images/gatos.png'
import equinos from '../images/equinos.png'

function ProdutosCertificadosFair4Them({ produtos, exibirMenu, resolucaoMobile, idioma, slugEmpresa }) {

    let produtosPorEspecie = {
        'Cães': produtos.filter((produto) => produto['Cães']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Gatos': produtos.filter((produto) => produto['Gatos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Equinos': produtos.filter((produto) => produto['Equinos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
    }

    const estiloTexto = { fontSize: '20px', color: 'white' }
    const estiloIcone = { height: '35px' }

    function produtoExisteNoIdiomaSelecionado(produto) {
        let exibirProduto = false

        if (idioma === 'pt') {
            exibirProduto = true
        } else if (idioma === 'en') {
            if (produto['Descrição do produto (Inglês)']) {
                exibirProduto = true
            }
        } else if (idioma === 'es') {
            if (produto['Descrição do produto (Espanhol)']) {
                exibirProduto = true
            }
        }

        return exibirProduto
    }

    function montarSecaoEspecie(titulo, especie, imagem) {
        return <div>
            <div style={{ gap: '10px' }} className='mt-5 d-flex align-items-center justify-content-center'>
                <Image style={estiloIcone} src={imagem} alt='logo' fluid />
                <span style={estiloTexto}>{titulo}</span>
            </div>
            <div style={{ gap: '20px' }} className='mb-2 mt-5 d-flex flex-wrap align-items-center justify-content-center'>
                {produtosPorEspecie[`${especie}`]?.map((produto) => <CardProdutoFair4Them key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} slugEmpresa={slugEmpresa} />)}
            </div>
        </div>
    }

    return (
        <>
            <TituloNegrito texto={retornarTexto(idioma, 'produtosCertificados')} />
            <div style={{ width: '80vw' }} className='mb-2 d-flex flex-column align-items-center justify-content-center'>

                {/* Cães */}
                {produtosPorEspecie?.Cães?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Dogs' : idioma === 'es' ? 'Perros' : 'Cães', 'Cães', caes) : <></>}

                {/* Equinos */}
                {produtosPorEspecie?.Equinos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Equines' : idioma === 'es' ? 'Equinos' : 'Equinos', 'Equinos', equinos) : <></>}

                {/* Gatos */}
                {produtosPorEspecie?.Gatos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Cats' : idioma === 'es' ? 'Gatos' : 'Gatos', 'Gatos', gatos) : <></>}

            </div>
        </>
    );
}
export default ProdutosCertificadosFair4Them;
